angular.module('PinMeTo.services').service('pmtEnabledNetworksService', [
	'auth',
	'pmtUtilService',
	function (auth, pmtUtilService) {
		'use strict';
		const networksWithPartialUpdate = new Set(['google', 'facebook', 'bing', 'apple']),
			AllCountries = 'All';

		const getCountriesForNetwork = (() => {
			const noCountries = new Set([]);
			const networksNotSupportingAllCountries = {
				google: { include: new Set([AllCountries]), exclude: new Set([`China`]) }
			};

			return network => {
				return (
					networksNotSupportingAllCountries[network] || {
						include: new Set([AllCountries]),
						exclude: noCountries
					}
				);
			};
		})();

		const hasCountry = (network, country = null) => {
			const lookup = getCountriesForNetwork(network);
			const include = lookup.include.has(AllCountries) || lookup.include.has(country);
			const exclude = lookup.exclude.has(country);
			return !exclude && include;
		};

		const get = (site, country = null) => {
			const site_ = site || auth.user.selectedSite;
			const analytics = site_.analytics;
			const places = site_.places;

			const initialState = {
				customDataEnabled: pmtUtilService.getByPath(['customData', 'enabled'], places)
			};
			return Object.getOwnPropertyNames(analytics)
				.filter(network => country == null || hasCountry(network, country))
				.reduce((acc, p) => {
					acc[`${p}Enabled`] = pmtUtilService.getByPath([p, 'enabled'], analytics);
					return acc;
				}, initialState);
		};

		const isEnabled = (network, site, country = null) => {
			const enabled = pmtUtilService.getByPath(
				['analytics', network, 'enabled'],
				site || auth.user.selectedSite
			);
			return enabled && country ? hasCountry(network, country) : enabled;
		};

		const enabledNetworks = (site, country = null) =>
			Object.getOwnPropertyNames(site.analytics)
				.filter(network =>
					pmtUtilService.getByPath(
						['analytics', network, 'enabled'],
						site || auth.user.selectedSite
					)
				)
				.filter(network => country == null || hasCountry(network, country));

		const enabledNetworksWithPartialUpdate = (site, country = null) => {
			const site_ = site || auth.user.selectedSite;
			return Object.getOwnPropertyNames(site_.analytics)
				.filter(network => {
					const connection = pmtUtilService.getByPath(['networkConnections', network], site_);
					if (connection) {
						return connection.connected;
					}
					return true;
				})
				.filter(network => pmtUtilService.getByPath(['analytics', network, 'enabled'], site_))
				.filter(network => networksWithPartialUpdate.has(network))
				.filter(network => country == null || hasCountry(network, country))
				.sort();
		};

		return {
			get: get,
			isEnabled: isEnabled,
			enabledNetworks: enabledNetworks,
			enabledNetworksWithPartialUpdate: enabledNetworksWithPartialUpdate
		};
	}
]);
